export function tabsCreate() {
  $(".my-tabs").click(function(){
      const tab_group = $(this).data('rel')
      const tab_content = $(this).data('content')
      const tab_stuff = $(this).data('parcel')

      $(".my-tabs[data-rel='"+ tab_group +"']").removeClass("active")
      $(this).addClass("active")
      $(".my-tabs[data-content='"+ tab_content  +"']").addClass("active")

      $(".my-tabs-content[data-rel='"+ tab_group +"']").hide()
      $(".my-tabs-content[data-stuff='"+ tab_stuff +"']").show()
      $("#"  + $(this).attr("data-content")).fadeIn();
  });
}

export function tabsInit() {
  $(".my-tabs-content").hide()
  $(".my-tabs.active").each(function(){
      const tab_ativa = $(this).attr("data-content")
      $("#" + tab_ativa).show()
  });

  $(".my-tabs-content.active.parcel").show()

}

export function tabImageHighlightCategories() {
  const img = $("#highlight-categories-img-wrapper img");
  const defaultSrc = img.src;
  
  $("#nav-categoriesContent").on("click", function({target}) {
    const details = target.closest("details");

    if (!details) return;
    const { src, alt } = details.dataset;
    img.attr({src: src, alt: alt});

    // try {
    //   img.addClass("skeleton");
    // } catch (error) {
    //   img.attr("src", defaultSrc);
    // } finally {
    //   img.removeClass("skeleton");
    // }
  })
}
